module.exports = __webpack_public_path__ + "img/guize_img.763b3a38.png";